module.exports = __webpack_public_path__ + "img/WF_24_parigi_sm.f75f26ed.jpg";